import { useEffect, useState } from 'react';

/** Player choice. Missing or anything other than "true" stays off. */
const STORAGE_KEY = 'rush-debug-enabled';
const CHANGED = 'rush:debug-changed';

/**
 * The development site offers a Debug item. The window stays closed
 * until the player turns it on. UAT and production builds omit the item.
 */
export function isDevEnvironment(): boolean {
  return import.meta.env.DEV === true || import.meta.env.VITE_DEBUG_MODE === 'true';
}

export function isDebugEnabled(): boolean {
  if (!isDevEnvironment()) return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setDebugEnabled(on: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, on ? 'true' : 'false');
  } catch {
    // The window stays at its last known state.
  }
  window.dispatchEvent(new CustomEvent(CHANGED, { detail: on }));
}

export function useDebugEnabled(): boolean {
  const [on, setOn] = useState(isDebugEnabled);

  useEffect(() => {
    const sync = () => setOn(isDebugEnabled());
    window.addEventListener(CHANGED, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGED, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return on;
}
